<template>
    <div>
        <span class="formDisclaimer">PLEASE COMPLETE ALL OF THE FOLLOWING REQUIRED FIELDS. INCOMPLETE FORMS WILL NOT BE CONSIDERED.</span>
        <hr class="titleBorder">        
        <h6 class="sectionCaption">CONTACT INFORMATION</h6>
        <b-container fluid>
            <!-- Contact Information : Name / Phone / Fax / Email -->
            <b-row>
                <b-col cols="5">
                    <b-form-group
                        label="Name"
                        label-for="contactName"
                        invalid-feedback="* Required">
                        <b-form-input id="contactName" type="text" trim lazy placeholder="" maxlength="100" 
                            v-model="$v.newRequest.contactName.$model"                            
                            :state="$v.newRequest.contactName.$dirty ? !$v.newRequest.contactName.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="7">
                    <b-form-group
                        label="Email"
                        label-for="contactEmail"
                        invalid-feedback="* Required: Must be a valid email address.">
                        <b-form-input id="contactEmail" type="text" trim lazy placeholder="" maxlength="250" 
                            v-model="$v.newRequest.contactEmail.$model"
                            :state="$v.newRequest.contactEmail.$dirty ? !$v.newRequest.contactEmail.$error : null"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="3">
                    <b-form-group
                        label="Phone"
                        label-for="contactPhone"
                        invalid-feedback="* Required">
                        <b-form-input id="contactPhone" type="tel" trim lazy v-mask="{ mask: '(999) 999-9999', placeholder: '#', autoUnmask: false }"
                            v-model="$v.newRequest.contactPhone.$model"
                            :state="$v.newRequest.contactPhone.$dirty ? !$v.newRequest.contactPhone.$error : null"></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="3">
                    <b-form-group
                        label="Fax"
                        label-for="contactFax"
                        invalid-feedback="Must be in (###) ###-#### format.">
                        <b-form-input id="contactFax" type="tel" trim lazy v-mask="{ mask: '(999) 999-9999', placeholder: '#', autoUnmask: false }"
                            v-model="$v.newRequest.contactFax.$model"
                            :state="$v.newRequest.contactFax.$dirty ? !$v.newRequest.contactFax.$error : null"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>

        <hr class="sectionBorder">
        <h6 class="sectionCaption">PRACTICE INFORMATION</h6>        
        <b-container fluid>
            <!-- Provider Types -->
            <b-row>
                <b-col cols="12">
                    <div>
                        <b-form-group>
                            <div class="grp-caption">Provider Type
                                <b-form-invalid-feedback :state="$v.newRequest.selectedProviderType.$dirty ? !$v.newRequest.selectedProviderType.$error : null"> * Required: Please select a Provider Type</b-form-invalid-feedback>
                            </div>                           
                            <b-form-radio
                                name="providerTypes"
                                v-for="providerType in optionsProviderTypes"
                                v-model="$v.newRequest.selectedProviderType.$model"
                                :key="providerType.Id"
                                :value="providerType.Id"
                                inline
                                class="col-4"
                                @change="providerTypeChange">
                            {{ providerType.Description }}
                            </b-form-radio>
                        </b-form-group>
                        <!-- <div v-if="showSelectedRecapSection">Selected: <strong>{{ this.newRequest.selectedProviderType }}</strong></div> -->

                        <!-- AssociatedWithCurrentlyContractedEntity  -->
                        <b-form-group
                            v-show="showCurrentlyContractedInput">
                            <div>
                                <b-form-invalid-feedback :state="$v.newRequest.associatedWithCurrentlyContractedEntity.$dirty ? !$v.newRequest.associatedWithCurrentlyContractedEntity.$error : null"><b>* Required</b><br/></b-form-invalid-feedback>
                                <span style="padding-right:10px;">{{ this.currentlyContractedQuestion }}</span>
                                <b-form-radio-group
                                    id="associatedWithCurrentlyContractedEntity"
                                    v-model="$v.newRequest.associatedWithCurrentlyContractedEntity.$model"
                                    style="display: inline-block;">
                                    <b-form-radio value="Y">Yes</b-form-radio>
                                    <b-form-radio value="N">No</b-form-radio>
                                </b-form-radio-group>
                            </div>
                        </b-form-group>
                        <br/>
                    </div>
                </b-col>            
            </b-row>

            <!-- Practice Types -->
            <b-row>
                <b-col cols="12">
                    <div v-show="showPracticeTypes">
                        <b-form-group>
                            <div class="grp-caption">Practice Type
                                <b-form-invalid-feedback :state="$v.newRequest.selectedPracticeType.$dirty ? !$v.newRequest.selectedPracticeType.$error : null"> * Required: Please select a Practice Type</b-form-invalid-feedback>
                            </div>
                            <b-form-radio
                                v-for="practiceType in optionsPracticeTypes"
                                v-model="$v.newRequest.selectedPracticeType.$model"
                                :key="practiceType.Id"
                                :value="practiceType.Id"
                                name="practiceTypes"
                                inline
                                class="col-3"
                                @change="otherPracticeTypeChange">
                                    {{ practiceType.Description }}
                            </b-form-radio>
                            <b-form-group>
                                <b-form-radio
                                    v-model="$v.newRequest.selectedPracticeType.$model"
                                    :key="otherPracticeType.Id"
                                    :value="otherPracticeType.Id"
                                    name="practiceTypes"
                                    inline
                                    @change="otherPracticeTypeChange">
                                        {{ this.otherPracticeType.Description }}
                                </b-form-radio>
                                <b-form-invalid-feedback :state="$v.newRequest.otherPracticeTypeDescription.$dirty ? !$v.newRequest.otherPracticeTypeDescription.$error : null">* Required: Please enter the Practice Type.</b-form-invalid-feedback>
                                <b-form-input trim lazy v-model="$v.newRequest.otherPracticeTypeDescription.$model" :placeholder="otherPracticeTypeInputPlaceholder" :disabled="disableOtherPracticeTypeInput" maxlength="500"></b-form-input>
                            </b-form-group>
                        </b-form-group>
                        <!-- <div v-if="showSelectedRecapSection">Selected: <strong>{{ this.newRequest.selectedPracticeType }}</strong><br/><br/></div> -->
                    </div>
                </b-col>            
            </b-row>

            <!-- Facility Types -->
            <b-row>
                <b-col cols="12">
                    <div v-show="showFacilityTypes">
                        <b-form-group>
                            <div class="grp-caption">Facility/Ancillary Provider Type
                                <b-form-invalid-feedback :state="$v.newRequest.selectedFacilityType.$dirty ? !$v.newRequest.selectedFacilityType.$error : null"> * Required: Please select a Facility/Ancillary Type</b-form-invalid-feedback>
                            </div>
                            <b-form-radio
                                v-for="facilityType in optionsFacilityTypes"
                                v-model="$v.newRequest.selectedFacilityType.$model"
                                :key="facilityType.Id"
                                :value="facilityType.Id"
                                name="facilityTypes"
                                inline
                                class="col-3"
                                @change="otherFacilityTypeChange">
                                    {{ facilityType.Description }}<span class="facility-additional-details-indicator" v-if="facilityType.EnableAdditionalDetails"> **</span>
                            </b-form-radio>
                            <b-form-group>
                                <b-form-radio
                                v-model="$v.newRequest.selectedFacilityType.$model"
                                :key="otherFacilityType.Id"
                                :value="otherFacilityType.Id"
                                name="facilityTypes"
                                inline
                                @change="otherFacilityTypeChange">
                                    {{ this.otherFacilityType.Description }}
                                </b-form-radio>
                                <b-form-invalid-feedback :state="$v.newRequest.otherFacilityTypeDescription.$dirty ? !$v.newRequest.otherFacilityTypeDescription.$error : null">* Required: Please enter the Facility Type.</b-form-invalid-feedback>
                                <b-form-input trim lazy v-model="$v.newRequest.otherFacilityTypeDescription.$model" :placeholder="otherFacilityTypeInputPlaceholder" :disabled="disableOtherFacilityTypeInput" maxlength="500"></b-form-input>
                            </b-form-group>
                        </b-form-group>
                        <!-- <div v-if="showSelectedRecapSection">Selected: <strong>{{ this.newRequest.selectedFacilityType }}</strong><br/><br/></div> -->

                        <!-- Service Areas -->
                        <b-form-group
                            v-show="showServiceAreasinput"
                            label-for="serviceAreas"
                            label="Service Areas (For Home Health; mobile providers and mail-order DME providers ONLY):"
                            invalid-feedback="* Required if any Facility/Ancillary Provider Types were selected with the ** indicator."
                            :state="$v.newRequest.serviceAreas.$dirty ? !$v.newRequest.serviceAreas.$error : null">
                            <b-form-input id="serviceAreas" type="text" trim lazy v-model="$v.newRequest.serviceAreas.$model" placeholder="" maxlength="500"></b-form-input>
                        </b-form-group>
                    </div>
                </b-col>            
            </b-row>
        </b-container>


        <hr class="sectionBorder">
        <h6 class="sectionCaption">DEMOGRAPHIC INFORMATION</h6>
        <b-container fluid>
            <!-- Practitioner Name / Tax ID / NPI / CAQH -->
            <b-row>
                <b-col v-show="showPracticeTypes" cols="6">
                    <b-form-group
                        label="Practitioner Name"
                        label-for="practitionerName">
                        <b-form-input id="practitionerName" type="text" trim lazy placeholder="" maxlength="250"
                            v-model="$v.newRequest.practitionerName.$model" >
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="2">
                    <b-form-group
                        label="Tax ID #"
                        label-for="taxId"
                        invalid-feedback="* Required: Must be in ##-####### format.">
                        <b-form-input id="taxId" type="text" trim lazy v-mask="{ mask: '99-9999999', placeholder: '#', autoUnmask: false }"
                            v-model="$v.newRequest.taxId.$model"
                            :state="$v.newRequest.taxId.$dirty ? !$v.newRequest.taxId.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="2">
                    <b-form-group
                        label="NPI #"
                        label-for="npi"
                        invalid-feedback="* Required: Must be in ########## format.">
                        <b-form-input id="npi" type="text" trim lazy v-mask="{ mask: '9999999999', placeholder: '#', autoUnmask: false }"
                            v-model="$v.newRequest.npi.$model"
                            :state="$v.newRequest.npi.$dirty ? !$v.newRequest.npi.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="2">
                    <b-form-group
                        label="CAQH #"
                        label-for="caqh"
                        invalid-feedback="* Must be in ######## format.">
                        <b-form-input id="caqh" type="text" trim lazy v-mask="{ mask: '99999999', placeholder: '#', autoUnmask: false }"
                            v-model="$v.newRequest.caqh.$model"
                            :state="$v.newRequest.caqh.$dirty ? !$v.newRequest.caqh.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>                
            </b-row>

            <!-- Business Phone / Extension / Business Fax / Business Email -->
            <b-row>
                <b-col cols="3">
                    <b-form-group
                        label="Business Phone"
                        label-for="businessPhone"
                        invalid-feedback="* Required">
                        <b-form-input id="businessPhone" type="tel" trim lazy v-mask="{ mask: '(999) 999-9999', placeholder: '#', autoUnmask: false }"
                            v-model="$v.newRequest.businessPhone.$model" 
                            :state="$v.newRequest.businessPhone.$dirty ? !$v.newRequest.businessPhone.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="2">
                    <b-form-group
                        label="Extension"
                        label-for="businessPhoneExtension">
                        <b-form-input id="businessPhoneExtension" type="text" trim lazy placeholder="" maxlength="6"
                            v-model="$v.newRequest.businessPhoneExtension.$model" >
                        </b-form-input>
                    </b-form-group>                    
                </b-col>
                
                <b-col cols="3">
                    <b-form-group
                        label="Business Fax"
                        label-for="businessFax"
                        invalid-feedback="Must be in (###) ###-#### format.">
                        <b-form-input id="businessFax" type="tel" trim lazy v-mask="{ mask: '(999) 999-9999', placeholder: '#', autoUnmask: false }"
                            v-model="$v.newRequest.businessFax.$model"
                            :state="$v.newRequest.businessFax.$dirty ? !$v.newRequest.businessFax.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="4">
                    <b-form-group
                        label="Business Email"
                        label-for="businessEmail"
                        invalid-feedback="Must be a valid email address.">
                        <b-form-input id="businessEmail" type="text"
                            trim lazy v-model="$v.newRequest.businessEmail.$model" placeholder="" maxlength="250"
                            :state="$v.newRequest.businessEmail.$dirty ? !$v.newRequest.businessEmail.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12">
                    <br/>
                </b-col>
            </b-row>

            <!-- Specialties -->
            <b-row v-show="showSpecialties">
                <b-col cols="6">
                    <div>
                        <b-form-group
                        label="Primary Specialty"
                        label-for="primarySpecialty"
                        invalid-feedback="* Required: Please select a Primary Specialty">
                            <b-form-select
                                id="primarySpecialty"
                                v-model="$v.newRequest.primarySpecialty.$model"
                                :options="optionsSpecialties"
                                :select-size="0"
                                value-field="Id"
                                text-field="Description"
                                :state="$v.newRequest.primarySpecialty.$dirty ? !$v.newRequest.primarySpecialty.$error : null">
                                <template v-slot:first>
                                    <option :value="null">-- Select a Primary Specialty --</option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <!-- <div v-if="showSelectedRecapSection">Selected Primary: <strong>{{ this.newRequest.primarySpecialty }}</strong></div> -->
                    </div>
                </b-col>
                <b-col cols="6">
                    <div>
                        <b-form-group
                            label="Secondary Specialty"
                            label-for="secondarySpecialty">
                            <b-form-select
                                id="secondarySpecialty"
                                v-model="$v.newRequest.secondarySpecialty.$model"
                                :options="optionsSpecialties"
                                :select-size="0"
                                value-field="Id"
                                text-field="Description">
                                <template v-slot:first>
                                    <option :value="null">-- Select a Secondary Specialty (if applicable) --</option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                        <!-- <div v-if="showSelectedRecapSection">Selected Secondary: <strong>{{ this.newRequest.secondarySpecialty }}</strong>
                            <br/><br/>
                        </div> -->
                    </div>
                </b-col>
            </b-row>
            <b-row v-show="showSpecialties">
                <b-col cols="12">
                    <br/>
                </b-col>
            </b-row>

            <!-- Business Name -->
            <b-row>
                <b-col cols="6">
                    <b-form-group
                        label="Business Name (as it appears on the W-9)"
                        label-for="businessName"
                        invalid-feedback="* Required">
                        <b-form-input id="businessName" type="text" trim lazy placeholder="" maxlength="250"
                            v-model="$v.newRequest.businessName.$model"                            
                            :state="$v.newRequest.businessName.$dirty ? !$v.newRequest.businessName.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- Primary Address -->
            <b-row>
                <b-col cols="9">
                    <b-form-group
                        label="Address"
                        label-for="primaryAddressAddressLine1"
                        invalid-feedback="* Required">
                        <b-form-input id="primaryAddressAddressLine1" type="text" trim lazy placeholder="" maxlength="250"
                            v-model="$v.newRequest.primaryAddress.addressLine1.$model"
                            :state="$v.newRequest.primaryAddress.addressLine1.$dirty ? !$v.newRequest.primaryAddress.addressLine1.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group
                        label="Suite"
                        label-for="primaryAddressSuite">
                        <b-form-input id="primaryAddressSuite" type="text" trim lazy placeholder="" maxlength="10"
                            v-model="$v.newRequest.primaryAddress.suite.$model">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="5">
                    <b-form-group
                        label="City"
                        label-for="primaryAddressCity"
                        invalid-feedback="* Required">
                        <b-form-input id="primaryAddressCity" type="text" trim lazy placeholder="" maxlength="50"
                            v-model="$v.newRequest.primaryAddress.city.$model"
                            :state="$v.newRequest.primaryAddress.city.$dirty ? !$v.newRequest.primaryAddress.city.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="2">
                    <b-form-group
                        label="State"
                        label-for="primaryAddressState"
                        invalid-feedback="* Required">
                        <b-form-input id="primaryAddressState" type="text" trim lazy placeholder="" maxlength="2"
                            v-model="$v.newRequest.primaryAddress.state.$model"
                            :state="$v.newRequest.primaryAddress.state.$dirty ? !$v.newRequest.primaryAddress.state.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                        label="Zip Code"
                        label-for="primaryAddressZipcode"
                        invalid-feedback="Must be in #####-#### format.">
                        <b-form-input id="primaryAddressZipcode" type="text" trim lazy v-mask="{ mask: '99999-9999', placeholder: '#', autoUnmask: true }"
                            v-model="$v.newRequest.primaryAddress.zipcode.$model"
                            :state="$v.newRequest.primaryAddress.zipcode.$dirty ? !$v.newRequest.primaryAddress.zipcode.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>                
            </b-row>
            <b-row>
                <b-col cols="12">
                    <br/>
                </b-col>
            </b-row>            

            <!-- Address: New Address Button / Modal Dialog -->
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <b-button @click="addAddress()">Click To Add Additional Addresses</b-button>
                        
                        <b-form-invalid-feedback :state="$v.newRequest.addresses.$dirty ? !$v.newRequest.addresses.$error : null"> * Required: Please enter at least one address.</b-form-invalid-feedback>
                        <b-modal id="add-address"
                            size="lg"
                            v-model="addAddressModalShowing"
                            no-close-on-esc
                            no-close-on-backdrop
                            hide-header-close
                            @show="showAddressDialog"
                            @hide="hideAddressDialog">
                            <template v-slot:modal-header="{ close }">
                                <h5>Add Address</h5>
                            </template>
                            
                            <template v-slot:default>
                                <b-container fluid>
                                    <!-- Address Information -->
                                    <b-row>
                                        <b-col cols="9">
                                            <b-form-group
                                                label="Address"
                                                label-for="address"
                                                invalid-feedback="* Required">
                                                <b-form-input id="address" type="text" trim lazy placeholder="" maxlength="250"
                                                    v-model="$v.newAddress.addressLine1.$model"
                                                    :state="$v.newAddress.addressLine1.$dirty ? !$v.newAddress.addressLine1.$error : null">
                                                </b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="3">
                                            <b-form-group
                                                label="Suite"
                                                label-for="suite">
                                                <b-form-input id="suite" type="text" trim lazy placeholder="" maxlength="10"
                                                    v-model="$v.newAddress.suite.$model">
                                                </b-form-input>
                                            </b-form-group>
                                        </b-col>
                                    </b-row>

                                    <b-row>
                                        <b-col cols="5">
                                            <b-form-group
                                                label="City"
                                                label-for="city"
                                                invalid-feedback="* Required">
                                                <b-form-input id="city" type="text" trim lazy placeholder="" maxlength="50"
                                                    v-model="$v.newAddress.city.$model"
                                                    :state="$v.newAddress.city.$dirty ? !$v.newAddress.city.$error : null">
                                                </b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="2">
                                            <b-form-group
                                                label="State"
                                                label-for="state"
                                                invalid-feedback="* Required">
                                                <b-form-input id="state" type="text" trim lazy placeholder="" maxlength="2"
                                                    v-model="$v.newAddress.state.$model"
                                                    :state="$v.newAddress.state.$dirty ? !$v.newAddress.state.$error : null">
                                                </b-form-input>
                                            </b-form-group>
                                        </b-col>
                                        <b-col cols="4">
                                            <b-form-group
                                                label="Zip Code"
                                                label-for="zipcode"
                                                invalid-feedback="Must be in #####-#### format.">
                                                <b-form-input id="zipcode" type="text" trim lazy v-mask="{ mask: '99999-9999', placeholder: '#', autoUnmask: true }"
                                                    v-model="$v.newAddress.zipcode.$model"
                                                    :state="$v.newAddress.zipcode.$dirty ? !$v.newAddress.zipcode.$error : null"></b-form-input>
                                            </b-form-group>
                                        </b-col>                
                                    </b-row>
                                </b-container>
                            </template>

                            <template v-slot:modal-footer="{ ok, cancel, hide }">
                                <b-button size="sm" variant="success" @click="handleOkNewAddress">
                                    OK
                                </b-button>
                                <b-button size="sm" variant="danger" @click="handleCancelNewAddress">
                                    Cancel
                                </b-button>
                            </template>
                        </b-modal>
                    </b-form-group>
                </b-col>
            </b-row>

            <!-- Address Grid -->
            <b-row>
                <b-col cols="12">
                    <b-table
                        id="addresses"
                        striped
                        hover
                        :items="getSecondaryAddresses"
                        :fields="addressesFields">
                        <template v-slot:cell(actions)="row">
                            <b-button size="sm" @click="editAddress(row.item, row.index, $event.target)" class="mr-1">
                            Edit
                            </b-button>
                            <b-button size="sm" @click="deleteAddress(row.item, row.index, $event.target)" class="mr-1">
                            Delete
                            </b-button>
                        </template>

                        <template v-slot:cell(url)="{ value }">
                            <b-link :href="value">link</b-link>
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-container>



        <hr class="sectionBorder">
        <h6 class="sectionCaption">SERVICE INFORMATION</h6>
        <b-container fluid>
            <!-- Population Types -->
            <b-row>
                <b-col cols="12">
                    <b-form-group>
                        <div>Ages Served
                            <b-form-invalid-feedback :state="
                                ($v.newRequest.servesAges_0_2.$dirty
                                    && $v.newRequest.servesAges_2_18.$dirty
                                    && $v.newRequest.servesAges_18_Plus.$dirty
                                    && $v.newRequest.servesAges_Geriatric.$dirty
                                    && $v.newRequest.servesAges_Other.$dirty)
                                && (!$v.newRequest.servesAges_0_2.$model
                                    && !$v.newRequest.servesAges_2_18.$model
                                    && !$v.newRequest.servesAges_18_Plus.$model
                                    && !$v.newRequest.servesAges_Geriatric.$model
                                    && !$v.newRequest.servesAges_Other.$model)
                                ? false : null"> * Required: Please select all that apply
                            </b-form-invalid-feedback>
                        </div>
                        <b-form-group style="margin-bottom:0px !important;" inline>
                            <b-form-checkbox
                                v-model="$v.newRequest.servesAges_0_2.$model"
                                name="servesAges_0_2"
                                inline
                                class="col-2">
                                {{ "0-2 Years" }}
                            </b-form-checkbox>
                            <b-form-checkbox
                                v-model="$v.newRequest.servesAges_2_18.$model"
                                name="servesAges_2_18"
                                inline
                                class="col-2">
                                {{ "2-18 Years" }}
                            </b-form-checkbox>
                            <b-form-checkbox
                                v-model="$v.newRequest.servesAges_18_Plus.$model"
                                name="servesAges_18_Plus"
                                inline
                                class="col-2">
                                {{ "18+ Years" }}
                            </b-form-checkbox>                            
                            <b-form-checkbox
                                v-model="$v.newRequest.servesAges_Geriatric.$model"
                                name="servesAges_Geriatric"
                                inline
                                class="col-2">
                                {{ "Geriatrics" }}
                            </b-form-checkbox>                            
                        </b-form-group>
                        <b-form-group class="" inline>
                                <b-form-checkbox
                                    v-model="$v.newRequest.servesAges_Other.$model"
                                    name="servesAges_Other"
                                    inline
                                    class=""
                                    @change="otherPopulationTypeChange">
                                    {{ "Other" }}
                                </b-form-checkbox>
                                <b-form-invalid-feedback :state="$v.newRequest.otherPopulationTypeDescription.$dirty ? !$v.newRequest.otherPopulationTypeDescription.$error : null">* Required: Please enter an Age Range</b-form-invalid-feedback>
                                <b-form-input trim lazy v-model="$v.newRequest.otherPopulationTypeDescription.$model" :placeholder="otherPopulationTypeInputPlaceholder" :disabled="disableOtherPopulationTypeInput" maxlength="500"></b-form-input>
                        </b-form-group>                        
                    </b-form-group>
                    <!-- <div v-if="showSelectedRecapSection">Selected: <strong>{{ this.newRequest.selectedPopulationTypes }}</strong><br/><br/></div> -->
                </b-col>
            </b-row>

            <!-- Languages / Office Hours -->
            <b-row>
                <b-col cols="6">
                    <b-form-group>
                        <div>Languages Spoken (other than English)
                            <b-form-invalid-feedback :state="$v.newRequest.selectedLanguages.$dirty ? !$v.newRequest.selectedLanguages.$error : null"> * Required: Please select at least 1 Language spoken</b-form-invalid-feedback>
                        </div>
                        <div class="list-group checkbox-list-group"
                            style="margin-top: 5px; border: 1px solid rgb(206, 212, 218); border-radius: 0.25rem; padding: 3px; max-height: 380px; overflow-x: hidden !important; overflow-y: scroll;">
                            <div v-for="language in optionsLanguages" :key="language.Id" class="custom-control custom-checkbox">
                                <input type="checkbox" name="languages" :value="language.Id" :id="'language_' + language.Id" v-model="$v.newRequest.selectedLanguages.$model" class="custom-control-input">
                                <label class="custom-control-label" :for="'language_' + language.Id">{{language.Description}}</label>
                            </div>
                        </div>                        
                        <b-form-group
                            style="padding-top: 7px; padding-right: 0px; padding-bottom: 0px; padding-left: 3px;"
                            inline>
                            <b-form-checkbox
                                v-model="$v.newRequest.selectedLanguages.$model"
                                :key="otherLanguage.Id"
                                :value="otherLanguage.Id"
                                name="otherLanguages"
                                inline
                                class=""
                                @change="otherLanguageChange">
                                {{ this.otherLanguage.Description }}
                            </b-form-checkbox>
                            <b-form-invalid-feedback :state="$v.newRequest.otherLanguageDescription.$dirty ? !$v.newRequest.otherLanguageDescription.$error : null">* Required: Please enter the Languages spoken.</b-form-invalid-feedback>
                            <b-form-input trim lazy v-model="$v.newRequest.otherLanguageDescription.$model" :placeholder="otherLanguageInputPlaceholder" :disabled="disableOtherLanguageInput" maxlength="500"></b-form-input>
                        </b-form-group>
                    </b-form-group>
                    <!-- <div v-if="showSelectedRecapSection">Selected: <strong>{{ this.newRequest.selectedLanguages }}</strong></div> -->
                </b-col>

                <b-col cols="6">
                    <b-form-group>
                        Office Hours
                        <b-container fluid style="margin-top: 5px; border: 1px solid rgb(206, 212, 218); border-radius: 0.25rem; padding: 5px; height: 380px; overflow-x: hidden !important; overflow-y: hidden;">
                            <b-row>
                                <b-col cols="12">
                                    <b-form-group
                                        label="Monday:"
                                        label-cols="2"
                                        label-align="right"
                                        label-for="officeHoursMonday">
                                        <b-form-input id="officeHoursMonday" type="text" trim lazy placeholder="" maxlength="100"
                                            v-model="$v.newRequest.officeHoursMonday.$model">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        label="Tuesday:"
                                        label-cols="2"
                                        label-align="right"
                                        label-for="officeHoursTuesday">
                                        <b-form-input id="officeHoursTuesday" type="text" trim lazy placeholder="" maxlength="100"
                                            v-model="$v.newRequest.officeHoursTuesday.$model">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        label="Wednesday:"
                                        label-cols="2"
                                        label-align="right"
                                        label-for="officeHoursWednesday">
                                        <b-form-input id="officeHoursWednesday" type="text" trim lazy placeholder="" maxlength="100"
                                            v-model="$v.newRequest.officeHoursWednesday.$model">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        label="Thursday:"
                                        label-cols="2"
                                        label-align="right"
                                        label-for="officeHoursThursday">
                                        <b-form-input id="officeHoursThursday" type="text" trim lazy placeholder="" maxlength="100"
                                            v-model="$v.newRequest.officeHoursThursday.$model">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        label="Friday:"
                                        label-cols="2"
                                        label-align="right"
                                        label-for="officeHoursFriday">
                                        <b-form-input id="officeHoursFriday" type="text" trim lazy placeholder="" maxlength="100"
                                            v-model="$v.newRequest.officeHoursFriday.$model">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        label="Saturday:"
                                        label-cols="2"
                                        label-align="right"
                                        label-for="officeHoursSaturday">
                                        <b-form-input id="officeHoursSaturday" type="text" trim lazy placeholder="" maxlength="100"
                                            v-model="$v.newRequest.officeHoursSaturday.$model">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        label="Sunday:"
                                        label-cols="2"
                                        label-align="right"
                                        label-for="officeHoursSunday">
                                        <b-form-input id="officeHoursSunday" type="text" trim lazy placeholder="" maxlength="100"
                                            v-model="$v.newRequest.officeHoursSunday.$model">
                                        </b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>                                                                                                                                            
                        </b-container>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>


        <hr class="sectionBorder">
        <h6 class="sectionCaption">NETWORK AFFILIATIONS</h6>
        <b-container fluid>
            <!-- MHMD Affiliation / Ohter IPA/PHO Affiliations -->            
            <b-row>
                <b-col cols="2">
                    <b-form-group>
                        <div>
                            <b-form-invalid-feedback :state="$v.newRequest.mhmdApplied.$dirty ? !$v.newRequest.mhmdApplied.$error : null">* Required<br/></b-form-invalid-feedback>
                            Have you ever applied to MHMD?
                        </div>
                        <b-form-radio-group
                            id="mhmdApplied"
                            v-model="$v.newRequest.mhmdApplied.$model">
                            <b-form-radio value="Y" @change="mhmdAppliedChange">Yes</b-form-radio>
                            <b-form-radio value="N" @change="mhmdAppliedChange">No</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                    <!-- <div v-if="showSelectedRecapSection">Selected: <strong>{{ newRequest.mhmdApplied }}</strong></div> -->
                </b-col>
                <b-col cols="5" align-self="end">
                    <div v-show="mhmdAppliedYes">
                        <b-form-group>
                            <label for="mhmdApplicationStatus">If yes, please select one of the following:</label>
                            <b-form-invalid-feedback :state="$v.newRequest.mhmdApplicationStatus.$dirty ? !$v.newRequest.mhmdApplicationStatus.$error : null"> * Required</b-form-invalid-feedback>
                            <b-form-select
                                id="mhmdApplicationStatus"
                                v-model="$v.newRequest.mhmdApplicationStatus.$model"
                                :options="optionsMHMDApplicationStatuses"
                                :state="$v.newRequest.mhmdApplicationStatus.$dirty ? !$v.newRequest.mhmdApplicationStatus.$error : null"
                                :select-size="0"
                                value-field="Id"
                                text-field="Description"
                                @change="mhmdApplicationStatusChange">
                            </b-form-select>
                        </b-form-group>
                        <div v-show="mhmdApplicationStatusTermindated">
                            <b-form-group>
                                <label for="mhmdApplicationStatus">Terminated Date</label>
                                <b-form-invalid-feedback :state="$v.newRequest.mhmdTerminatedDate.$dirty ? !$v.newRequest.mhmdTerminatedDate.$error : null"> * Required</b-form-invalid-feedback>
                                <b-form-input id="mhmdTerminatedDate" trim lazy v-mask="{ mask: '99/99/9999', placeholder: '#', autoUnmask: false }"
                                    v-model="$v.newRequest.mhmdTerminatedDate.$model"
                                    :state="$v.newRequest.mhmdTerminatedDate.$dirty ? !$v.newRequest.mhmdTerminatedDate.$error : null">
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <!-- <div v-if="showSelectedRecapSection">
                            Selected Application Status: <strong>{{ this.newRequest.mhmdApplicationStatus }}</strong>
                            <br/><br/>
                        </div> -->
                    </div>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col cols="12">
                    <b-form-group
                        label="Other Network/IPA/PHO Affliations"
                        label-for="otherIPAPHOAffiliations">
                        <b-form-input id="otherIPAPHOAffiliations" type="text" trim lazy  placeholder="" maxlength="500"
                            v-model="$v.newRequest.otherIPAPHOAffiliations.$model">
                        </b-form-input>
                    </b-form-group>
                    <br/>
                </b-col>                
            </b-row>
        </b-container>


        <hr class="sectionBorder">
        <h6 class="sectionCaption">CREDENTIALING CONTACT INFORMATION</h6>
        <b-container fluid>
            <!-- Credintialing Contact / Email / Phone -->
            <b-row>
                <b-col cols="4">
                    <b-form-group
                        label="Credentialing Contact"
                        label-for="credentialingContactName"
                        invalid-feedback="* Required">
                        <b-form-input id="credentialingContactName" type="text" trim lazy placeholder="" maxlength="100"
                            v-model="$v.newRequest.credentialingContactName.$model"
                            :state="$v.newRequest.credentialingContactName.$dirty ? !$v.newRequest.credentialingContactName.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="4">
                    <b-form-group
                        label="Credentialing Contact E-mail Address"
                        label-for="credentialingContactEmail"
                        invalid-feedback="* Required: Must be a valid email address.">
                        <b-form-input id="credentialingContactEmail" type="text" trim lazy placeholder="" maxlength="250"
                            v-model="$v.newRequest.credentialingContactEmail.$model" 
                            :state="$v.newRequest.credentialingContactEmail.$dirty ? !$v.newRequest.credentialingContactEmail.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>

                <b-col cols="4">
                    <b-form-group
                        label="Credentialing Contact Phone #"
                        label-for="credentialingContactPhone"
                        invalid-feedback="* Required">
                        <b-form-input id="credentialingContactPhone" type="tel" trim lazy v-mask="{ mask: '(999) 999-9999', placeholder: '#', autoUnmask: false }"
                            v-model="$v.newRequest.credentialingContactPhone.$model"
                            :state="$v.newRequest.credentialingContactPhone.$dirty ? !$v.newRequest.credentialingContactPhone.$error : null">
                        </b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-container>


        <b-container fluid>
            <!-- Submit Button / Print Button -->
            <b-row>
                <b-col cols="6" style="text-align: end;">
                    <br/>
                    <b-button type="submit" v-if="!requestSubmitted" @click="submitForm" variant="primary">Submit</b-button>
                    &nbsp;<b-button type="submit" v-if="requestSubmitted" @click="printForm" variant="primary">Print</b-button>
                    <br/><br/>
                </b-col>
                <b-col cols="6" style="text-align: start;">
                    <vue-recaptcha
                        size="normal"
                        ref="recaptcha"
                        sitekey="6Le78xIUAAAAAB5HNSsND1LJLg_61mLDHF2vrRej"
                        :loadRecaptchaScript=true
                        @verify="onVerify"
                        @expired="onExpired"
                        @error="onError">
                    </vue-recaptcha>
                </b-col>
            </b-row>
        </b-container>

    </div>
</template>

<script>

import {
    required,
    minLength,
    maxLength,
    requiredIf,
    email,
    helpers } from 'vuelidate/lib/validators'

import { mapState, mapGetters, mapActions } from 'vuex';
import VueRecaptcha from 'vue-recaptcha';

const EIN = helpers.regex('EIN', /\d{2}[-]\d{7}$/)  // with mask
//const EIN = helpers.regex('EIN', /\d{9}$/) // without mask

const NPI = helpers.regex('NPI', /^[0-9]{10}$/)  // with mask
//const NPI = helpers.regex('NPI', /^\d{10}$/) // without mask

const CAQH = helpers.regex('CAQH', /^[0-9]{8}$/)  // with mask
//const CAQH = helpers.regex('CAQH', /^\d{8}$/) // without mask

const PhoneNumber = helpers.regex('PhoneNumber', /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/) // with mask
//const PhoneNumber = helpers.regex('PhoneNumber', /\d{10}$/) // without mask

//const ZipCode = helpers.regex('ZipCode', /^\d{5}(-\d{4})?$/) // with mask
const ZipCode = helpers.regex('ZipCode', /^\d{5}(\d{4})?$/) // without mask

// eslint-disable-next-line no-unused-vars
const AgesServed = (value, vm) => vm.servesAges_0_2 || vm.servesAges_2_18 || vm.servesAges_18_Plus || vm.servesAges_Geriatric || vm.servesAges_Other;

//https://stackoverflow.com/questions/16699007/regular-expression-to-match-standard-10-digit-phone-number
//^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$
//const EIN = (value) => !helpers.req(value) || helpers.regex(value, /\d{2}[-]\d{7}$/);

export default {
    created() {
        this.loadAll()
        .then(() => {
            if(this.$store.state.dataError) {
                this.$store.dispatch('udpateStatus', 'error');
                this.$store.commit('updateDataError', false, { root: true });
                this.$router.push('/error');
            }            
        });
    },
    
    data() {
        return {
        //modelIsDirty: false,

        currentlyContractedQuestion: '',
        otherPracticeTypeInputPlaceholder: 'If Other, enter a Practice Type',
        disableOtherPracticeTypeInput: true,

        otherFacilityTypeInputPlaceholder: 'If Other, enter a Facility Type',
        disableOtherFacilityTypeInput: true,

        showServiceAreasinput: false,

        addressModalAction: '',
        addAddressModalShowing: false,

        otherPopulationTypeInputPlaceholder: 'If Other, Enter Age Range',
        disableOtherPopulationTypeInput: true,

        otherLanguageInputPlaceholder: 'If Other, Enter Languages',
        disableOtherLanguageInput: true,

        addressesFields: [
            { key: 'addressLine1', label: 'Address' },
            { key: 'suite', label: 'Suite' },
            { key: 'city', label: 'City' },
            { key: 'state', label: 'State' },
            { key: 'zipcode', label: 'Zip', formatter: 'zipCodeFormatter'},
            { key: 'actions', label: 'Actions' },
            ],
        showSelectedRecapSection: true,
        captchaVerified: false,
        }
    },

    validations: {
        newRequest: {

            contactName: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(100),
            },
            contactEmail: {
                required,
                email,
            },
            contactPhone: {
                required,
                PhoneNumber,
            },
            contactFax: {
                PhoneNumber,
            },

            selectedProviderType: {
                required,
            },

            associatedWithCurrentlyContractedEntity: {
                required: requiredIf(function (){
                    return this.showPracticeTypes || this.showFacilityTypes;
                }),
            },

            selectedPracticeType: {
                required: requiredIf(function (){
                    return this.showPracticeTypes;
                }),
            },
            otherPracticeTypeDescription: {
                required: requiredIf(function () {
                    return this.otherPracticeTypeChecked;
                }),
            },

            selectedFacilityType: {
                required: requiredIf(function (){
                    return this.showFacilityTypes;
                }),
            },
            otherFacilityTypeDescription: {
                required: requiredIf(function () {
                    return this.otherFacilityTypeChecked;
                }),                
            },
            serviceAreas: {
                required: requiredIf(function () {
                    return this.showServiceAreasinput;
                }),
            },

            practitionerName: {
            },
            businessName: {
                required,
                minLength: minLength(3),
            },
            taxId: {
                required,
                EIN,
            },
            npi: {
                required,
                NPI,
            },
            caqh: {
                CAQH,
            },

            businessPhone: {
                required,
                PhoneNumber,
            },
            businessPhoneExtension: {
            },
            businessFax: {
                PhoneNumber,
            },
            businessEmail: {
                email,
            },

            primarySpecialty: {
                required: requiredIf(function () {
                    return this.showSpecialties;
                }),
            },
            secondarySpecialty: {
            },

            servesAges_0_2: {
                AgesServed,
            },
            servesAges_2_18: {
                AgesServed,
            },
            servesAges_18_Plus: {
                AgesServed,
            },
            servesAges_Geriatric: {
                AgesServed,
            },
            servesAges_Other: {
                AgesServed,
            },            

            primaryAddress: {
              id: {},
              addressLine1: {
                  required,
                  minLength: minLength(3),
              },
              suite: {},
              city: {
                  required,
                  minLength: minLength(3),
              },
              state: {
                  required,
                  minLength: minLength(2),
              },
              zipcode: {
                  required,
                  ZipCode,
              },
              isPrimary: {},
            },                

            addresses: {
            },

            otherPopulationTypeDescription: {
                required: requiredIf(function () {
                    return this.otherPopulationTypeChecked;
                }),
            },

            selectedLanguages: {
            },
            otherLanguageDescription: {
                required: requiredIf(function () {
                    return this.otherLanguageChecked;
                }),                
            },            

            officeHoursMonday: {
            },
            officeHoursTuesday: {
            },
            officeHoursWednesday: {
            },
            officeHoursThursday: {
            },
            officeHoursFriday: {
            },
            officeHoursSaturday: {
            },
            officeHoursSunday: {
            },

            mhmdApplied: {
                required,
            },
            mhmdApplicationStatus: {
                required: requiredIf(function () {
                    return this.mhmdAppliedYes;
                    }),
            },
            mhmdTerminatedDate: {
                required: requiredIf(function () {
                    return this.mhmdApplicationStatusTermindated;
                })
            },
            otherIPAPHOAffiliations: {
            },

            credentialingContactName: {
                required,
            },
            credentialingContactEmail: {
                required,
                email,
            },
            credentialingContactPhone: {
                required,
                PhoneNumber,
            },
        },

        
        newAddress: {
          id: {},
          addressLine1: {
            required: requiredIf(function () {
                return this.addAddressModalShowing;
            }),
            minLength: minLength(3),
          },
          suite: {},
          city: {
            required: requiredIf(function () {
                return this.addAddressModalShowing;
            }),
            minLength: minLength(3),
          },
          state: {
            required: requiredIf(function () {
                return this.addAddressModalShowing;
            }),
            minLength: minLength(2),
          },
          zipcode: {
            required: requiredIf(function () {
                return this.addAddressModalShowing;
            }),
            ZipCode,
          },
          isPrimary: {},
        },
        newAddressValidation: ['newAddress.addressLine1', 'newAddress.city', 'newAddress.state', 'newAddress.zipcode',]
    },

    computed: {
        ...mapState(
            'request', {
                optionsProviderTypes: 'providerTypes',                
                optionsPracticeTypes: 'practiceTypes',
                otherPracticeType: 'otherPracticeType',
                optionsFacilityTypes: 'facilityTypes',
                otherFacilityType: 'otherFacilityType',
                optionsSpecialties: 'specialties',
                optionsLanguages: 'languages',
                otherLanguage: 'otherLanguage',
                optionsMHMDApplicationStatuses: 'MHMDApplicationStatuses',
                newRequest: 'newRequest',
                newAddress: 'newAddress',
                }
        ),
        
        ...mapGetters(
            'request', {
                getSecondaryAddresses: 'getSecondaryAddresses',
            }
        ),

        getSelectedProviderType(){
            return this.newRequest.selectedProviderType;
        },

        showCurrentlyContractedInput() {
            return this.newRequest.selectedProviderType;
        },

        showPracticeTypes() {
            return this.newRequest.selectedProviderType === 1;
        },
        otherPracticeTypeChecked() {
            return this.newRequest.selectedPracticeType === 999;
        },

        showFacilityTypes() {
            return this.newRequest.selectedProviderType === 2;
        },
        otherFacilityTypeChecked() {
            return this.newRequest.selectedFacilityType === 999;
        },
        getSelectedFacilityTypes(){
            return this.newRequest.selectedFacilityType;
        },

        showSpecialties(){
            return this.newRequest.selectedProviderType === 1;
        },

        mhmdAppliedYes() {
            return this.newRequest.mhmdApplied === 'Y';
        },
        mhmdApplicationStatusTermindated() {
            return this.newRequest.mhmdApplicationStatus === 7;
        },

        otherPopulationTypeChecked() {
            return this.newRequest.servesAges_Other === true;
        },

        otherLanguageChecked() {
            return this.newRequest.selectedLanguages.includes(999);
        },

        requestSubmitted() {
            return this.$store.state.requestSubmitted;
        }
    },

    mounted () {
        this.$nextTick(function (){
            // Used to load mock data.
            //this.$store.commit('request/initializeStateWithData');
        })
    },

    methods: {
        ...mapActions(
            'request', {
                loadAll: 'loadAll',
                loadProviderTypes: 'loadProviderTypes',                
                loadPracticeTypes: 'loadPracticeTypes',
                loadFacilityTypes: 'loadFacilityTypes',
                loadSpecialties: 'loadSpecialties',
                loadLanguages: 'loadLanguages',
                loadMHMDApplicationStatuses: 'loadMHMDApplicationStatuses',
                addRequest: 'addRequest',
                }
        ),

        providerTypeChange (checked) {
            this.newRequest.associatedWithCurrentlyContractedEntity = null;

            if(checked === 1) {
                this.currentlyContractedQuestion = 'Is the practitioner joining a group that is currently contracted with Memorial Hermann Health Plan?';
                this.newRequest.selectedFacilityType = '';
                this.newRequest.otherFacilityTypeDescription = '';
                this.disableOtherFacilityTypeInput = true;
            }
            if(checked === 2) {
                this.currentlyContractedQuestion = 'Is this a new location for a company that is currently contracted with Memorial Hermann Health Plan?';
                this.newRequest.selectedPracticeType = '';
                this.newRequest.otherPracticeTypeDescription = '';
                this.disableOtherPracticeTypeInput = true;
                this.newRequest.practitionerName = '';
            }
        },
                
        otherPracticeTypeChange (checked) {
            if(!this.$v.newRequest.otherPracticeTypeDescription.$dirty) {
                this.$v.newRequest.otherPracticeTypeDescription.$touch();
            }

            switch(checked) {
                case 999:
                    this.disableOtherPracticeTypeInput = false;
                    break;

                default:
                    this.newRequest.otherPracticeTypeDescription = '';
                    this.disableOtherPracticeTypeInput = true;
                    break;
            }
        },

        otherFacilityTypeChange (checked) {
            if(!this.$v.newRequest.otherFacilityTypeDescription.$dirty) {
                this.$v.newRequest.otherFacilityTypeDescription.$touch();
            }

            switch(checked) {
                case 999:
                    this.disableOtherFacilityTypeInput = false;
                    break;

                default:
                    this.newRequest.otherFacilityTypeDescription = '';
                    this.disableOtherFacilityTypeInput = true;
                    break;
            }
        },
        
        handleOkNewAddress(bvModalEvt) {
            if(this.$v.newAddressValidation.$invalid){
                this.$v.newAddressValidation.$touch();
                bvModalEvt.preventDefault();
                return;
            }

            if(this.addressModalAction === 'add') {

                var maxId = 0;
                maxId = Math.max(...this.newRequest.addresses.map(o => o.id), 0) + 1;

                var newAddress = 
                {
                    id: maxId,
                    addressLine1: this.newAddress.addressLine1,
                    suite: this.newAddress.suite,
                    city: this.newAddress.city,
                    state: this.newAddress.state,
                    zipcode: this.newAddress.zipcode,
                    isPrimary: this.newAddress.isPrimary,
                };

                this.$store.commit('request/addAddress', newAddress);
                this.$bvModal.hide('add-address');

            } else if (this.addressModalAction === 'edit') {
                var updateAddress = 
                {
                    id: this.newAddress.id,
                    addressLine1: this.newAddress.addressLine1,
                    suite: this.newAddress.suite,
                    city: this.newAddress.city,
                    state: this.newAddress.state,
                    zipcode: this.newAddress.zipcode,
                    isPrimary: this.newAddress.isPrimary,
                };

                this.$store.commit('request/updateAddress', updateAddress);
                this.$bvModal.hide('add-address');                
            }
        },
        handleCancelNewAddress() {
            this.resetNewAddressState();
            this.$bvModal.hide('add-address');
        },

        showAddressDialog (/*bvModalEvt*/){
            if(this.addressModalAction === 'add') {
                this.$store.commit('request/resetNewAddress');
                this.resetNewAddressState();
            } else if (this.addressModalAction === 'edit') {
                this.resetNewAddressState();
            }
        },
        hideAddressDialog (/*bvModalEvt*/) {
            this.$store.commit('request/resetNewAddress');
            this.resetNewAddressState();
        },

        resetNewAddress() {
            if(this.addressModalAction === 'add')
            {
             this.$store.commit('request/resetNewAddress');
             this.resetNewAddressState();
            }
        },
        resetNewAddressState(){
            this.$v.newAddressValidation.$reset();
        },
        addAddress() {
            this.addressModalAction = 'add';
            this.$bvModal.show('add-address');
        },
        editAddress(item /*, index, button */) {
            //alert(`Button: ${button.innerHTML}\n` + `Row index: ${index}\n` + `Item:\n ${JSON.stringify(item, null, 2)}`);
            
            this.addressModalAction = 'edit';
            this.$store.commit('request/loadAddress', item.id);
            this.$bvModal.show('add-address');

        },
        deleteAddress(item) {
            this.$store.commit('request/deleteAddress', item.id)
        },
        zipCodeFormatter(value) {
            var result = "";
            if(value.length == 5)
            {
                result = value.substring(0, 5);
            } else if (value.length == 9) { 
                result = value.substring(0, 5) + '-' + value.substring(5, 9);
            }
             
            return `${result}`;
        },
        booleanToYNFormatter(value) {
            return `${(value == null ? "" : value == "true" ? "Yes" : "No")}`;
        },

        onVerify: function (response) {
            this.captchaVerified = true;
            this.newRequest.captchaResponse = response;
            
            //eslint-disable-next-line no-console
            //console.log('captchaResponse: [' + this.newRequest.captchaResponse + ']');
        },
        onExpired: function (){
            this.captchaVerified = false;
            this.newRequest.captchaResponse = '';

            //eslint-disable-next-line no-console
            //console.log('captchaResponse: [' + this.newRequest.captchaResponse + ']');            
        },
        onError: function (){
            alert('Captcha Error');
        },

        submitForm(evt) {
            evt.preventDefault();

            this.$v.$touch();

            // eslint-disable-next-line no-console
            // console.log(JSON.stringify(this.newRequest));

            // alert(this.$v.$error)            
            // alert(JSON.stringify(this.$v.newRequest.contactName));
            // alert(JSON.stringify(this.$v.newRequest.contactName.$error));
            
            if(this.$v.$invalid) {
                alert('Some fields are either missing or incorrect. Please complete/correct them and try again.');
            }
            else if (!this.captchaVerified) {
                alert("Please check the 'Im not a robot' checkbox on the right.");
            } else {
                this.addRequest()
                .then(() => {
                    if(this.$store.state.requestSubmitted)
                    {
                        this.$store.dispatch('udpateStatus', 'print');
                        this.$router.push('/printRequest');
                    } else {
                        if(this.$store.state.requestSubmitCount < 3) {
                            var tryAgainMessage = 'Sorry but we seem to be experiencing difficulties submitting your request form.' + '\n\n';
                            if(this.$store.state.requestSubmitCount === 1) {
                                tryAgainMessage += 'Please check you have an internet connection and try submitting your request again.'
                            } else if(this.$store.state.requestSubmitCount === 2) {
                                tryAgainMessage += 'Please wait a few more seconds and try submitting your request once more.'
                            }
                            alert(tryAgainMessage);
                        } else {
                            var errorMessage = 'Sorry but we seem to be experiencing difficulties submitting your request form.' + '\n\n';
                            errorMessage += 'You will be routed to a Print page so you can print your request form as a pdf and email it to MHHPContractingRFP@memorialhermann.org.';
                            alert(errorMessage);

                            this.$store.dispatch('udpateStatus', 'print');
                            this.$router.push('/printRequest');                            
                        }
                    }

                });
            }
        },
        
        //*** Determine if this is needed ***
        printForm(evt) {
            evt.preventDefault();

            this.$store.dispatch('udpateStatus', 'print')
            .then(this.$router.push('/printRequest'));
        },

        // *** Determine if this is needed ***
        status(validation) {
            return {
                error: validation.$error,
                dirty: validation.$dirty
            }
        },


        otherPopulationTypeChange (checked) {
            if(!this.$v.newRequest.otherPopulationTypeDescription.$dirty) {
                this.$v.newRequest.otherPopulationTypeDescription.$touch();
            }

            if(!checked) {
                this.newRequest.otherPopulationTypeDescription = '';
                this.disableOtherPopulationTypeInput = true;
            } else {
                this.disableOtherPopulationTypeInput = false;
            }
        },

        otherLanguageChange (checked) {
            if(!this.$v.newRequest.otherLanguageDescription.$dirty) {
                this.$v.newRequest.otherLanguageDescription.$touch();
            }

            if(checked == null) {
                this.newRequest.otherLanguageDescription = '';
                this.disableOtherLanguageInput = true;
            } else {
                this.disableOtherLanguageInput = false;
            }
        },

        mhmdAppliedChange (checked) {
            if(this.$v.newRequest.mhmdApplicationStatus.$dirty) {
                this.$v.newRequest.mhmdApplicationStatus.$reset();
            }

            if(checked == null || checked === 'N') {
                this.newRequest.mhmdApplicationStatus = '';
                this.newRequest.mhmdTerminatedDate = '';
            }
        },
        mhmdApplicationStatusChange (value) {
            if(value != 7) {
                this.newRequest.mhmdTerminatedDate = '';
            }
        },
    },

    watch: {
        getSelectedProviderType() {
            if(this.newRequest.selectedProviderType !== 1)
            {
                if(this.$v.newRequest.primarySpecialty.$dirty) {
                    this.$v.newRequest.primarySpecialty.$reset();
                }

                this.newRequest.primarySpecialty = null;
                this.newRequest.secondarySpecialty = null;
            }

            if(this.$v.newRequest.associatedWithCurrentlyContractedEntity.$dirty) {
                this.$v.newRequest.associatedWithCurrentlyContractedEntity.$reset();
            }
        },

        getSelectedFacilityTypes() {
            if(this.showFacilityTypes
                && this.optionsFacilityTypes.filter(ft => ft.EnableAdditionalDetails === true).map(function(a) {return a.Id}).includes(this.newRequest.selectedFacilityType))
            {
                this.showServiceAreasinput = true;
            } else {
                this.newRequest.serviceAreas = '';
                this.showServiceAreasinput = false;
            }
        },
        // newRequest: {
        //     // eslint-disable-next-line no-unused-vars
        //     handler(val, oldVal) {
        //         this.modelIsDirty = true;
        //         // eslint-disable-next-line no-console                
        //         console.log('modelIsDirty: ' + this.modelIsDirty);
        //     },
        //     deep: true
        // },
    },
    components: {
        'vue-recaptcha': VueRecaptcha
    },    
}
</script>

<style scoped>
/* @media print {
  body {-webkit-print-color-adjust: exact;}
}
@page {
    size:A4 landscape;
    margin-left: 0px;
    margin-right: 0px;
    margin-top: 0px;
    margin-bottom: 0px;
    margin: 0;
    -webkit-print-color-adjust: exact;
} */
.formDisclaimer {
    color:green;
    font-size: small;
    font-weight: bolder;
    padding-bottom: 5px;
}
.grp-caption {
    font-size: large;
    font-weight: bolder;
    padding-bottom: 5px;
    display:flexbox;
}
hr.sectionBorder {
  border: 1px dashed black;
}
h6.sectionCaption {
  font-weight: bold;
  text-align: center
}

/* input {
  border: 1px solid silver;
  border-radius: 4px;
  background: white;
  padding: 5px 10px;
}
.dirty {
  border-color: #5A5;
  background: #EFE;
}
.dirty:focus {
  outline-color: #8E8;
}
.error {
  border-color: red;
  background: #FDD;
}
.error:focus {
  outline-color: #F99;
}
 */
.form-control.is-invalid{
    background-image: none;
}
.form-control.is-valid{
    background-image: none;
}
/* .custom-select.is-invalid {
    background-image: none;    
} */
/* .custom-select.is-valid {
    background-image: none;
} */
.d-block {
    display: inline !important;
}
.facility-additional-details-indicator {
    color: red;
}
/* .checkbox.checked:after {
  content: '';
  display: block;
  width: 4px;
  height: 7px;
  
   position:relative;
  top:4px;
  left:7px;
  
  border: solid #000;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
} */
</style>